import { Injectable } from '@angular/core';
import { DropdownItem } from '../../models/dropdown-item';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { FlashMessagesService } from '../../../shared/flash-messages/service/flash.messages.service';
import { ChainBrandStoreInterface } from './chain-brand.store.interface';
import { ChainBrandHttpService } from './chain-brand.http-service';
import { ChainBrandMapper } from './chain-brand.mapper';
import { Brand } from '../../models/chain-brand/brand';

@Injectable()
export class ChainBrandStore implements ChainBrandStoreInterface {

  get chainBrandHttpService() { return this._chainBrandHttpService; }
  private brands$: BehaviorSubject<DropdownItem[]> = new BehaviorSubject([]);
  private chains$: BehaviorSubject<DropdownItem[]> = new BehaviorSubject([]);

  constructor(
    private _chainBrandHttpService: ChainBrandHttpService,
    private flashMessagesService: FlashMessagesService) { }

  loadChains(): Observable<DropdownItem[]> {
    return this._chainBrandHttpService.getChains()
      .catch((error: any) => {
        this.flashMessagesService.error(
          'MESSAGES.ERROR.COULD_NOT_GET_CHAINS',
          `Error retrieving chains: ${error}`
        );
        return Observable.throw(error);
      })
      .map(chains => ChainBrandMapper.convertChainsToDropDownItem(chains))
      .map((chains: DropdownItem[]) => {
        this.chains$.next(chains);
        return chains;
      });
  }

  loadBrandsFromChain(chainCode: string): Observable<DropdownItem[]> {
    return this.getBrandsFromChain(chainCode)
      .map(brands => ChainBrandMapper.convertBrandsToDropDownItem(brands))
      .map(brands => {
        this.brands$.next(brands);
        return brands;
      });
  }

  get brands(): Observable<DropdownItem[]> {
    return this.brands$.asObservable();
  }

  get chains(): Observable<DropdownItem[]> {
    return this.chains$.asObservable();
  }

  private getBrandsFromChain(chainCode: string): Observable<Brand[]> {
    if (!chainCode) {
      return Observable.of([]);
    } else {
      return this._chainBrandHttpService.getBrands(chainCode)
        .catch((error: any) => {
          this.flashMessagesService.error(
            'MESSAGES.ERROR.COULD_NOT_GET_BRANDS',
            `Error retrieving brands: ${error}`
          );
          return Observable.throw(error);
        });
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/service/chainbrand/chain-brand.store.ts